import { Route, Routes } from "react-router-dom";
import "./App.css";

import Home from "./Components/Home/Home";

import Navbar from "./Components/Navbar/Navbar";
import { Login } from "./componentsB/authentication/Login";
import { Register } from "./componentsB/authentication/Register";

import { Payments } from "./componentsB/Payments";
import React from "react";

import CheckOut from "./Components/Home/CheckOut";

import { ProductLanding } from "./Components/ProductFlights/ProductLanding/ProductLanding";


function App() {


  const [isToken, setIsToken] = React.useState(null);

  return (
    <div className="App">
      <Navbar isToken={isToken} setIsToken={setIsToken} />
     
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/flight" element={<ProductLanding />} />

        <Route path="/checkout" element={<CheckOut />} />
        <Route
          path="/check"
          element={<Payments isToken={isToken} setIsToken={setIsToken} />}
        />
        <Route
          path="/login"
          element={<Login isToken={isToken} setIsToken={setIsToken} />}
        />

        <Route path="/register" element={<Register />} />
      </Routes>

     {/* footer aayega */}
     
    </div>
  );
}

export default App;
